// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../../../../library/NetworkUtils.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as LoadAssistInfoRepoConfig from "./LoadAssistInfoRepoConfig.bs.js";

var loadAssistInfoDummyResponse = {
    "order_info": [
      {
        "order_crn": "CRN1428080439",
        "schedule_order_id": 4720,
        "requirement_uuid": "f7414574-21a5-4474-916e-8472a56585af",
        "vehicle_info": {
          "type": "tata_ace",
          "vehicle_image_url": "https://dom-prod-vehicle-icons-cdn.porter.in/icon-images/images_2.0/Tata_Ace_Closed_enlarged_4.5ft.png",
          "tnc": [
            "2 Partners",
            "Load upto full truck load",
            "Max weight per item is 50 kg",
            "Max total weight is 750 kg"
          ],
          "waypoints_enabled": false
        },
        "item_info": {
          "load_description": "Above 300 kg",
          "item_details": {
            "type": "other_items",
            "service_info": {
              "icon_url": "https://dom-prod-vehicle-icons-cdn.porter.in/vas-images/driver_and_labour.png",
              "partner_count": 2,
              "description": "Loading & unloading"
            }
          }
        },
        "location_info": [
          {
            "location_type": "Pickup",
            "lift_type": "ServiceLift",
            "floor": 0,
            "labour_requirement": "Loading"
          },
          {
            "location_type": "Drop",
            "lift_type": "NoLift",
            "floor": 3,
            "labour_requirement": "Unloading"
          }
        ]
      }
    ]
  };

function fetchLoadAssistInfo(param, param$1) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: loadAssistInfoDummyResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(LoadAssistInfoRepoConfig.LoadAssistInfoResponseConverter.execute, result);
                            });
                }), "fetchLoadAssistInfo");
}

var LoadAssistInfoRepo = {
  fetchLoadAssistInfo: fetchLoadAssistInfo
};

export {
  LoadAssistInfoRepo ,
  
}
/* NetworkUtils Not a pure module */
